// import React from 'react';
import React, { useState, useEffect, PureComponent, useRef, useMemo, useCallback, Fragment } from 'react';
import Pagination from './Pagination'
import { NavLink } from 'react-router-dom';
import "./EpicfinanceTrends.css";
import * as ReactBootstrap from 'react-bootstrap';
import $ from 'jquery';
import config from '../config';
import Sidebar from '../SideMenu';
const DailyUpdateFunction = () => {
  const [currentPage, setcurrentPage] = useState(1);
  const [postsPerPage, setpostsPerPage] = useState(10);
  const [AssetAllocation, setAssetAllocation] = useState([]);
  
  const [News, setNews] = useState([]);
  
  const [NewsArrState, setNewsArrState] = useState([]);
  const [status, setstatus] = useState(false);
  
  useEffect(() => {
    fetchMyAPI()
  }, [])


  const latestNews = () => {

    var news_date;
    var news_heading;
    var NewsArr = []
    var id;
    var news_slug;
    var NewsKeys = ["heading", "date", "id", "slug"];

    for (let i = 0; i < News.length; i++) {
      let obj = {};


      news_heading = News[i].heading;
      news_date = News[i].date;
      // news_slug = News[i].slug || "default-slug";
      news_slug = News[i].slug;
     // id = News[i].id


      let calculatedDate = new Date(news_date).toLocaleDateString("en-US", { day: 'numeric' }) + "/" + new Date(news_date).toLocaleDateString("en-US", { month: 'short' }) + "/" + new Date(news_date).toLocaleDateString("en-US", { year: 'numeric' });


      obj[NewsKeys[0]] = news_heading;
      obj[NewsKeys[1]] = calculatedDate;
      //obj[NewsKeys[2]] = id;
      obj[NewsKeys[3]] = news_slug;
      NewsArr.push(obj);

    }



    setNewsArrState(NewsArr)


  }




  const [StateSession, setStateSession] = useState([]);
  const [SessionResponse, setSessionResponse] = useState([]);

  const SettingFunction = () => {

    setStateSession(SessionResponse);
    $('.footer-container').addClass('footer-container-line')
  }
  $(document).ready(function () {
    SettingFunction();

  });

  let count = 0;
  async function fetchMyAPI() {
    const Localurl = 'https://epicipprojects.com/dailyupdate'
    const url = config.apiPath + '/dailyupdate'
    fetch(config.apiPath + '/session_data').then(resp => resp.json()).then(resp => {
      setSessionResponse(resp);
    })
    fetch(url).then(resp => resp.json())
      .then(resp => {
        setAssetAllocation(resp.Assetsallocation)


        setNews(resp)


        // setLoading(true)
        setstatus(true)
        document.getElementById("summaryButton").click();

      })

      .catch(e => {

      })





  };



  function renderNewsData(data, index) {
    return (

      <div class="col-sm-12">
        <p className="news_download">
          <NavLink to={data.slug ? `/markets/DailyUpdatesData/${data.slug}` : '#'}>{data.date}<br />
            <span class="date">{data.heading}</span>
          </NavLink>
        </p>
      </div>
    )
  }
  function renderDailyPrices(DailyPrice, index) {
    if (DailyPrice.Price !== 0) {
      return (
        <div class="DailyPricing__DailyPriceCard-sc-62f3gi-1 coIgZR">
          <div class="DailyPricing__DailyPrice-sc-62f3gi-2 gsZde">${DailyPrice.Price}</div>
          <div class="DailyPricing__DailyPriceName-sc-62f3gi-3 iLShEo">Class A<br /><span className="daily-span">(USD) Shares</span></div>
        </div>
      )
    }
  }







  const indexofLastPost = currentPage * postsPerPage;
  const indexofFirstPost = indexofLastPost - postsPerPage;
  const currentPosts = NewsArrState.slice(indexofFirstPost, indexofLastPost);

  const paginate = pageNumber => setcurrentPage(pageNumber)

  return (
    <Fragment>

      {status === true ?

        <section className="main-box">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-3 col-sm-4">
                <Sidebar StateSession={{ StateSession: StateSession, "url": "EpicDailyUpdates", "group": "EPIC Insights" }} />
              </div>
              <div class="col-lg-8 col-md-8 col-sm-8 offset-md-1">
                <ul class="nav nav-tabs news-tab" role="tablist">
                  <li className="nav-item nav-item-tabs latest-news"> <a className="nav-link active latest-news" data-toggle="tab" id="summaryButton" onClick={latestNews} href="#nine" role="tab">Daily Updates</a> </li>
                </ul>
                <div class="Section__SectionContent-sc-1iot0f7-2 ">
                  {currentPosts.map(renderNewsData)}
                  <Pagination postPerPage={postsPerPage} totalPosts={NewsArrState.length} paginate={paginate} />

                </div>
              </div>
            </div>
          </div>
        </section>
        : <div className="center"><ReactBootstrap.Spinner animation="border" /></div>
      }
    </Fragment>
  );
}

export default DailyUpdateFunction;


